// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_CriaUsuarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /usuarios/criaUsuario
 *
 * Returns success flag plus the new user's Cognito sub so the wizard can
 * proceed to franchise assignment without a second user-list round-trip.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Usuarios_CriaUsuarioResponseDados {
created: boolean
sub: string
}

export type Usuarios_CriaUsuarioResponse = ApiResponse<Usuarios_CriaUsuarioResponseDados>;

registerResponseContract('Usuarios_CriaUsuarioResponse', {
  created: { type: 'boolean', required: true },
  sub:     { type: 'string',  required: true },
})
